import {Link} from 'react-router-dom'
import clsx from 'clsx'
import type {CSSProperties} from 'react'
import {KTSVG, getConnectLoginLogoUrl} from '../../../helpers'
import {useLayout} from '../../core'

const sidebarLogoImgStyle: CSSProperties = {
  height: '100%',
  maxHeight: 'var(--kt-app-header-height, 70px)',
  width: 'auto',
  maxWidth: '100%',
  objectFit: 'contain',
}

const SidebarLogo = () => {
  const {config} = useLayout()
  const appSidebarDefaultMinimizeDesktopEnabled =
    config?.app?.sidebar?.default?.minimize?.desktop?.enabled
  const appSidebarDefaultCollapseDesktopEnabled =
    config?.app?.sidebar?.default?.collapse?.desktop?.enabled
  const toggleType = appSidebarDefaultCollapseDesktopEnabled
    ? 'collapse'
    : appSidebarDefaultMinimizeDesktopEnabled
    ? 'minimize'
    : ''
  const toggleState = appSidebarDefaultMinimizeDesktopEnabled ? 'active' : ''
  const appSidebarDefaultMinimizeDefault = config.app?.sidebar?.default?.minimize?.desktop?.default
  const connectLoginLogoUrl = getConnectLoginLogoUrl()

  return (
    <div className='app-sidebar-logo px-6 ' id='kt_app_sidebar_logo'>
      <Link to='/dashboard' className='d-flex align-items-center h-100 flex-grow-1 overflow-hidden'>
        <img
          alt='Connect logo'
          src={connectLoginLogoUrl}
          className='app-sidebar-logo-default'
          style={sidebarLogoImgStyle}
        />

        <img
          alt='Connect logo'
          src={connectLoginLogoUrl}
          className='app-sidebar-logo-minimize'
          style={{height: '20px', width: 'auto', objectFit: 'contain'}}
        />
      </Link>

      {(appSidebarDefaultMinimizeDesktopEnabled || appSidebarDefaultCollapseDesktopEnabled) && (
        <div
          id='kt_app_sidebar_toggle'
          className={clsx(
            'app-sidebar-toggle btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary body-bg h-30px w-30px position-absolute top-50 start-100 translate-middle rotate',
            {active: appSidebarDefaultMinimizeDefault}
          )}
          data-kt-toggle='true'
          data-kt-toggle-state={toggleState}
          data-kt-toggle-target='body'
          data-kt-toggle-name={`app-sidebar-${toggleType}`}
        >
          <KTSVG path='/media/icons/duotune/arrows/arr079.svg' className='svg-icon-2 rotate-180' />
        </div>
      )}
    </div>
  )
}

export {SidebarLogo}
